"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"

import { adminSignupOnboardingQueryKey } from "@/hooks/queries/admin-signup-onboarding"
import { withQueryHandling } from "@/lib/with-query-handling"
import { restartAdminSignupOnboardingAction } from "@/server-actions/admin-signup-onboarding"

export function useRestartAdminSignupOnboardingMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (tenantId: string) => {
      const result = await withQueryHandling(
        restartAdminSignupOnboardingAction({ tenant_id: tenantId }),
        {
          loading: "Restarting onboarding...",
          success: "Onboarding restarted",
        },
      )
      if ("status" in result) throw new Error(result.errorMessage)
      return result.state
    },
    onSuccess: async (_state, tenantId) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [...adminSignupOnboardingQueryKey, "summaries"],
        }),
        queryClient.invalidateQueries({
          queryKey: [
            ...adminSignupOnboardingQueryKey,
            "details",
            tenantId,
          ],
        }),
      ])
    },
  })
}
